import "../style/form/packagesform.scss";
import { useDispatch, useSelector } from "react-redux";
import { packages, packagesid } from "../redux/reducer/counterslice";
import {
  Packagesget,
  InvestigationGet,
  presignedurl,
} from "../../text/apidata";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { Multiselect } from "multiselect-react-dropdown";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import TagsInput from "react-tagsinput";
import {datetimestring} from "../methods/Methods"

let u1 = [];

export default function PackagesForm(props) {
  const packagesstate = useSelector((state) => state.counter.packages);
  const packagesstateid = useSelector((state) => state.counter.packagesid);
  const [inclusiveserviceslist, setinclusiveservices] = useState([]);
  const [inclusiveservicesdata, setinclusiveservicesdata] = useState([]);
  const [searchquery, setsearchquery] = useState("");
  const [checked, setchecked] = useState(true);
  const [file, setFile] = useState([]);
  const [imgfile, setimgfile] = useState([]);
  const [imgtype, setimgtype] = useState([]);
  const [mapurl, setmapurl] = useState([]);
  const [preurl, setpreurl] = useState([]);
  const [CategoryName, setCategoryName] = useState(["Service Packages"]);
  const [alert, setalert] = useState(false);
  const [isactive, setisactive] = useState(false);

  const [packagesdata, setpackagesdata] = useState({
    category: "",
    category_name: "",
    sub_category_name: "",
    unit_cost: "0",
    description: "",
    discount: "0",
    need_prescription: true,
    inclusive_services: [],
    featured_image: [],
    package_images: [],
    location_id: "",
    location_name: "",
    featured_product: false,
    is_active: false,
    code:"",
    package_description:"",
    instructions:"",
    time_required:"",

  });
  const [location, setloaction] = useState([
    { value: "CHETPET", id: "90" },
    { value: "VELACHERY", id: "91" },
    { value: "KOLATHUR", id: "92" },
  ]);
  const [checked1, setChecked1] = useState(false);

  const [url, setUrl] = useState();
  const [imgfilenew, setimgfilenew] = useState([]);
  const [imgtypenew, setimgtypenew] = useState([]);
  const [preurlnew, setpreurlnew] = useState([]);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [portaldescription,setportaldescription]=useState("")
  const [error, seterror] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire(
          //   "Deleted!",
          //   "Given Info has been deleted.",
          //   "success"
          // );
          dispatch(packages(""));
          setalert(false);
        }
      });
    } else {
      dispatch(packages(""));
      setalert(false);
    }
  };
  const checkbox1 = (e) => {
    setalert(true);

    // console.log(e, e.target.checked);
    setChecked1(e.target.checked);
    setpackagesdata({
      ...packagesdata,
      [e.target.name]: e.target.checked,
    });
  };
  const checkbox2 = (e) => {
    setalert(true);
    setisactive(e.target.checked);
    setpackagesdata({
      ...packagesdata,
      [e.target.name]: e.target.checked,
    });
  };
  const validation = (e) => {
    setalert(true);

    console.log(e.target.value);
    const { name, value } = e.target;
    setpackagesdata({
      ...packagesdata,
      [name]: value,
    });
    if (name == "discount") {
      if (e.target.value != "") {
        if (e.target.value > 100) {
          // alert("No numbers above 100");
          setpackagesdata({
            ...packagesdata,
            [name]: 100,
          });
        } else {
          setpackagesdata({
            ...packagesdata,
            [name]: value,
          });
        }
      } else {
        setpackagesdata({
          ...packagesdata,
          [name]: 0,
        });
      }
    }

    if (name == "location_name") {
      console.log(e.target.options[e.target.selectedIndex].attributes[1].value);
      setpackagesdata({
        ...packagesdata,
        [name]: value,
        location_id:
          e.target.options[e.target.selectedIndex].attributes[1].value,
      });
    }
  };

  const checkbox = (e) => {
    setalert(true);

    setchecked(!checked);
    const { name, value } = e.target;
    setpackagesdata({
      ...packagesdata,
      [name]: !checked,
    });
  };

  const mltiselect = (e) => {
    setalert(true);

    console.log(e);
    let l1 = [];
    e.length > 0 &&
      e.map((ele) => {
        l1.push(ele.key);
      });
    setpackagesdata({
      ...packagesdata,
      inclusive_services: l1,
    });
  };

  useEffect(() => {
    if (packagesstate == "Edit") {
      //   props.loaderchange("true");

      axios({
        method: "get",
        url: Packagesget + packagesstateid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          console.log(res, "llll");
          let Array = [];
          let Arrayid = [];
          res.data.data.inclusive_services.forEach((element) => {
            Array.push({ key: element.id, name: element.description });
            Arrayid.push(element.id);
          });
          setinclusiveservices(Array);
          setchecked(res.data.data.need_prescription);
          setUrl(res.data.data.featured_image);
          setportaldescription(res.data.data.portal_description)
          //   props.loaderchange("false");
          setpackagesdata({
            ...packagesdata,
            category: res.data.data.category,
            category_name: res.data.data.category_name,
            sub_category_name: res.data.data.sub_category_name,
            unit_cost: res.data.data.unit_cost,
            description: res.data.data.description,
            discount: res.data.data.discount,
            need_prescription: res.data.data.need_prescription,
            visit_type: res.data.data.visit_type,
            inclusive_services: Arrayid,
            package_images: res.data.data.package_images,
            featured_image: res.data.data.featured_image,
            location_id: res.data.data.location_id,
            location_name: res.data.data.location_name,
            is_active: res.data.data.is_active,
            featured_product: res.data.data.featured_product,
            code:res.data.data.code,
            package_description:res.data.data.package_description,
            instructions:res.data.data.instructions,
            time_required:res.data.data.time_required,
        

          });



          setisactive(res.data.data.is_active);

          setFile(
            res.data.data.package_images != null
              ? res.data.data.package_images
              : ""
          );
          setChecked1(res.data.data.featured_product);

          res.data.data.package_images != null &&
            res.data.data.package_images.length > 0 &&
            res.data.data.package_images.map((ele) => {
              u1.push(ele);
            });
        })
        .catch((error) => {
          console.log(error);
          //   props.loaderchange("false");
        });
    }
    axios({
      method: "get",
      url: InvestigationGet,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      params: {
        page: searchquery == "" ? "1" : null,
        page_size: searchquery == "" ? "50" : null,
        search: searchquery,
      },
    })
      .then((res) => {
        let objectArray = [];
        console.log(res.data);
        res.data.data.forEach((element) => {
          // console.log(element.name, element.id);
          objectArray.push({ key: element.id, name: element.description });
        });
        setinclusiveservicesdata(objectArray);
        //   props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        //   props.loaderchange("false");
      });
  }, [packagesstate, searchquery]);

  const newusercreate = () => {
    console.log(packagesdata);
    if (
      packagesdata.category != "" &&
      packagesdata.category_name != "" &&
      packagesdata.sub_category_name != "" &&
      packagesdata.unit_cost != "" &&
      packagesdata.description != "" &&
      packagesdata.inclusive_services != "" &&
      packagesdata.package_images != "" &&
      packagesdata.featured_image != "" &&
      packagesdata.package_images != null &&
      packagesdata.featured_image != null
    ) {
      if (packagesstate == "Edit") {
        props.loaderchange("true");
        mapurl.forEach((ele) => {
          async function editimage() {
            const resp = await fetch(ele.url, {
              method: "PUT",
              body: ele.file,
              headers: {
                "Content-Type": ele.type,
                "X-Amz-ACL": "public-read",
              },
            })
              .then((res) => {
                console.log(res);
              })

              .catch((err) => {
                console.log(err);
                props.loaderchange("false");
                return null;
              });
          }
          editimage();
        });
        async function editimage1() {
          if (preurlnew && preurlnew.length > 0) {
            console.log(preurlnew, imgtypenew, imgfilenew);
            const resp = await fetch(preurlnew, {
              method: "PUT",
              body: imgfilenew,
              headers: {
                // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                "Content-Type": imgtypenew,
                "X-Amz-ACL": "public-read",
              },
            }).catch((err) => {
              console.log(err);
              return null;
            });
          }
        }

        editimage1();
        axios({
          method: "put",
          url: Packagesget + packagesstateid + "/",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          data: packagesdata,
        })
          .then((res) => {
            console.log(res);
            dispatch(packages(""));
            setFile([]);
            setimgfile([]);
            setimgtype([]);
            setmapurl([]);
            setpreurl([]);
            u1 = [];
            setalert(false);

            setpackagesdata({
              ...packagesdata,
              package_images: [],
            });

            props.popupalert("true");
            props.popuptext("Packages Updated Successfully");

            setTimeout(() => {
              props.popupalert("false");
            }, 2000);

            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        props.loaderchange("true");

        mapurl.forEach((ele) => {
          async function uploadimage() {
            const resp = await fetch(ele.url, {
              method: "PUT",
              body: ele.file,
              headers: {
                // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                "Content-Type": ele.type,
                "X-Amz-ACL": "public-read",
              },
            })
              .then((res) => {
                console.log(res);

                // props.loaderchange("false");
              })

              .catch((err) => {
                console.log(err);
                // props.loaderchange("false");
                return null;
              });
          }
          uploadimage();
        });
        async function uploadimage1() {
          if (preurlnew && preurlnew.length > 0) {
            const resp1 = await fetch(preurlnew, {
              method: "PUT",
              body: imgfilenew,
              headers: {
                // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                "Content-Type": imgtypenew,
                "X-Amz-ACL": "public-read",
              },
            }).catch((err) => {
              console.log(err);
              return null;
            });
          }
        }
        uploadimage1();
        axios({
          method: "post",
          url: Packagesget,
          data: packagesdata,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            console.log(res);
            dispatch(packages(""));
            setFile([]);
            setimgfile([]);
            setimgtype([]);
            setmapurl([]);
            setpreurl([]);
            u1 = [];
            setalert(false);

            setpackagesdata({
              ...packagesdata,
              package_images: [],
            });
            props.popupalert("true");
            props.popuptext("Packages Created Successfully");

            setTimeout(() => {
              props.popupalert("false");
            }, 2000);

            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      seterror(true);
      if (
        packagesdata.package_images == "" ||
        packagesdata.featured_image == "" ||
        packagesdata.package_images == null ||
        packagesdata.featured_image == null
      ) {
        props.popupalert("true");
        props.popuptext("Upload Packages Images ");

        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      }
    }
  };

  ///img
  const uploadSingleFile = (e) => {
    if (e.target.files.length == 1) {
      setalert(true);

      selectedImage(e);
      setCroppImageViewCount(2);
      setCroppImageView(true);
    } else if (e.target.files[0]) {
      setalert(true);

      console.log(e.target.files);
      var url;
      if (e.target.files.length > 0) {
        const filesArray = Array.from(e.target.files); // Convert FileList to array
        filesArray.forEach((ele) => {
          setFile((oldArray) => [
            ...oldArray,
            String(URL.createObjectURL(ele)),
          ]);
          setimgfile((oldArray) => [...oldArray, ele]);
          setimgtype((oldArray) => [...oldArray, ele.type]);
          // Do something with the 'url' object, if needed.
        });
        let filename_new = datetimestring()
        var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
        var val = Math.floor(1000 + Math.random() * 9000);

        url = {
          multiple_files: filesArray.map((file) => ({
            ["filename"]:
              "assestsfortesting" +
              "/" +
              String(val) +
              String(file.name).replace(/ +/g, ""),
            ["file_type"]: file.type,
          })),
        };

        setTimeout(() => {
          console.log(url);
        }, 1000);
        axios({
          method: "post",
          url: presignedurl,
          data: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            console.log(res);
            res.data.data.map((data, index) => {
              setpreurl((oldArray) => [...oldArray, data]);
              u1.push(data.split("?")[0]);
              setmapurl((oldArray) => [
                ...oldArray,
                {
                  url: data,
                  type: url.multiple_files[index]["file_type"],
                  file: filesArray[index],
                },
              ]);
            });

            console.log(mapurl);
            setpackagesdata({
              ...packagesdata,
              package_images: u1,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  const deleteFile = (e) => {
    setalert(true);

    const s = file.filter((item, index) => index !== e);
    const t = imgfile.filter((item, index) => index !== e);
    const u = preurl.filter((item, index) => index !== e);
    const v = mapurl.filter((item, index) => index !== e);
    const w = u1.filter((item, index) => index !== e);
    const i = imgtype.filter((item, index) => index !== e);

    setimgtype(i);
    setimgfile(t);
    setpreurl(u);
    setFile(s);
    setmapurl(v);
    console.log(w);
    u1 = [];

    u1 = w;
    console.log(u1);
    setpackagesdata({
      ...packagesdata,
      package_images: u1,
    });
  };

  ///
  const handleFiles = (e) => {
    selectedImage(e);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setalert(true);
  };

  const cancel = (e) => {
    setalert(true);

    setUrl("");
    setpackagesdata({
      ...packagesdata,
      featured_image: "",
    });
  };

  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };
  function getCroppedImg(a, crop, fileName) {
    const canvas = document.createElement("canvas");
      const image = document.getElementById("localimg");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      if(crop){
        canvas.width = crop.width;
      canvas.height = crop.height;
      }
      else{
        canvas.width = image.width;
      canvas.height = image.height;
      }
      const ctx = canvas.getContext("2d");
  if(crop){
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  
  }
  else{
    ctx.drawImage(
      image,
      scaleX,
      scaleY,
      image.width* scaleX,
      image.height* scaleY,
      0,
      0,
      image.width,
      image.height,
    );
  
  }
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error("Canvas is empty");
            return;
          }
          const croppedFile = new File([blob], "croppedimg.jpg", {
            type: "image/jpeg",
          });
          if (CroppImageViewCount == 1) {
            console.log(croppedFile);
            setimgfilenew(croppedFile);
            setimgtypenew(croppedFile.type);
            var file = croppedFile;
            var reader = new FileReader();
            reader.onloadend = function () {
              setUrl(reader.result);
            };
            reader.readAsDataURL(file);

            let filename_new = datetimestring()
            var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
            var url1 = {
              multiple_files: [
                {
                  ["filename"]:
                    "assestsfortesting" +
                    "/" +
                    String(val) +
                    String(croppedFile.name).replace(/ +/g, ""),
                  // ["file_type"]: e.target.files[0].type,
                  ["file_type"]: croppedFile.type,
                },
              ],
            };

            setTimeout(() => {
              axios({
                method: "post",
                url: presignedurl,
                data: url1,
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
              })
                .then((res) => {
                  setpreurlnew(String(res.data.data));

                  setpackagesdata({
                    ...packagesdata,
                    featured_image: String(res.data.data).split("?")[0],
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            }, 500);
          } else if (CroppImageViewCount == 2) {
            const filesArray1 = croppedFile; // Convert FileList to array
            setFile((oldArray) => [
              ...oldArray,
              String(URL.createObjectURL(croppedFile)),
            ]);

            setimgfile((oldArray) => [...oldArray, croppedFile]);
            setimgtype((oldArray) => [...oldArray, croppedFile.type]);
            var file = croppedFile;
            var reader = new FileReader();
            reader.readAsDataURL(file);

            let filename_new = datetimestring()
            var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
            var url = {
              multiple_files: [
                {
                  ["filename"]:
                    "assestsfortesting" +
                    "/" +
                    String(val) +
                    String(croppedFile.name).replace(/ +/g, ""),
                  // ["file_type"]: e.target.files[0].type,
                  ["file_type"]: croppedFile.type,
                },
              ],
            };
            setTimeout(() => {
              axios({
                method: "post",
                url: presignedurl,
                data: url,
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
              })
                .then((res) => {
                  console.log(res);
                  res.data.data.map((data, index) => {
                    setpreurl((oldArray) => [...oldArray, data]);
                    u1.push(data.split("?")[0]);
                    setmapurl((oldArray) => [
                      ...oldArray,
                      {
                        url: data,
                        type: url.multiple_files[index]["file_type"],
                        file: filesArray1,
                      },
                    ]);
                  });

                  console.log(mapurl);
                  setpackagesdata({
                    ...packagesdata,
                    package_images: u1,
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            }, 500);
          }
          blob.name = fileName;
          setCroppImageView(false);
          let fileUrl = window.URL.createObjectURL(blob);
          console.log(fileUrl);
          resolve(fileUrl);
        }, "image/jpeg");
      });
    
  }
  const setCompletedCrop = async (c) => {
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };



  return (
    <>
      <div className="maincontainer_packagesform">
        <div className="parent-packagesform">
          <div className="create-packagesform card">
            <div class="modal-header">
              <h5 class="modal-title">
                {packagesstate == "Edit" ? "Packages Edit" : "Packages Create"}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="modal-body" style={{ padding: "0 !important" }}>
              <form
                style={{ padding: "0 1.5rem 0rem" }}
                className="formspace"
                onSubmit={handleSubmit}
              >
                <div class="form-row">
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Category
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="category"
                      autoComplete="off"
                      value={packagesdata.category}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.category == ""
                        ? "Catagory Required"
                        : ""}{" "}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Unit Cost
                    </label>

                    <div style={{ display: "flex" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        ₹
                      </span>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn"
                        name="unit_cost"
                        autoComplete="off"
                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        value={packagesdata.unit_cost}
                        onChange={(e) => validation(e)}
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.unit_cost == ""
                        ? "Unit Cost Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Discount
                    </label>
                    <div style={{ display: "flex" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        %
                      </span>

                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        name="discount"
                        autoComplete="off"
                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        value={packagesdata.discount}
                        onChange={(e) => validation(e)}
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.discount == ""
                        ? "Discount Required"
                        : ""}
                    </p> */}
                  </div>
                </div>
                <div className="form-row">
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Category Name
                    </label>
                    {/* <input
                      type="text"
                      class="form-control"
                      id="validationCustom03"
                      name="category_name"
                      autoComplete="off"
                      value={packagesdata.category_name}
                      onChange={(e) => validation(e)}
                    ></input>
 */}
                    <select
                      className="form-select"
                      name="category_name"
                      value={packagesdata.category_name}
                      onChange={(e) => validation(e)}
                    >
                      <option selected disabled value={""}>
                        ...Please Select
                      </option>
                      {CategoryName.map((data) => {
                        return <option value={data}>{data} </option>;
                      })}
                    </select>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.category_name == ""
                        ? "Category Name  Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Sub Category Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom03"
                      name="sub_category_name"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      value={packagesdata.sub_category_name}
                      onChange={(e) => validation(e)}
                    ></input>

                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.sub_category_name == ""
                        ? "Sub Category Name  Required"
                        : ""}
                    </p>
                  </div>

                  {/* <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom04" class="form-label">
                      Visit Type
                    </label>
                    <select
                      class="form-select"
                      id="validationCustom04"
                      value={packagesdata.visit_type}
                      name="visit_type"
                    onChange={(e) => validation(e)}
                    >
                      <option selected disabled value="">
                        Choose...
                      </option>
                       {visittype.map((data) => {
                        return <option value={data}>{data}</option>;
                      })}
                    </select>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.visit_type == ""
                        ? "Status Required"
                        : ""}
                    </p>
                  </div> */}

                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Description
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="description"
                      value={packagesdata.description}
                      style={{ resize: "none" }}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      rows="3"
                    ></textarea>

                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.description == ""
                        ? "Date Time  Required"
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="form-row">
                  
                {packagesstate == "Edit"&&<div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Kranium Description
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="description"
                      value={portaldescription}
                      style={{ resize: "none",cursor:"not-allowed" }}
                      readOnly
                      rows="3"
                    ></textarea>

                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.description == ""
                        ? "Date Time  Required"
                        : ""}
                    </p>
                  </div>}
                  <div class="form-group col-md-4 p-1 m-0">
                    <label class="form-label">Location Name</label>

                    <select
                      className="form-select"
                      value={packagesdata.location_name}
                      onChange={(e) => validation(e)}
                      name="location_name"
                    >
                      <option selected disabled value="">
                        ...Please Select
                      </option>
                      {location.map((data) => {
                        return (
                          <option value={data.value} data={data.id}>
                            {data.value}
                          </option>
                        );
                      })}
                    </select>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.location_name == ""
                        ? "Location Name  Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label class="form-label">Location Id</label>
                    <input
                      class="form-control"
                      name="location_id"
                      value={packagesdata.location_id}
                      style={{cursor:"not-allowed"}}
                      readOnly
                    ></input>
                  </div>
                </div>
                <div className="form-row">
                <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Code
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="code"
                      autoComplete="off"
                      value={packagesdata.code}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.code == ""
                        ? "code Required"
                        : ""}{" "}
                    </p>
                  </div>
                  <div className="form-group col-md-8 p-2 m-0">
                    <label for="validationCustom04" class="form-label">
                      Inclusive Services
                    </label>

                    <Multiselect
                      onSelect={(e) => mltiselect(e)}
                      onRemove={(e) => mltiselect(e)}
                      options={inclusiveservicesdata}
                      selectedValues={inclusiveserviceslist}
                      onSearch={(e) => {
                        setsearchquery(e);
                      }}
                      caseSensitiveSearch={true}
                      showArrow={true}
                      displayValue="name"
                      showCheckbox={true}
                      // disable={true}
                      //   placeholder="Select speciality*"
                      placeholder="Search"
                      style={{
                        fontSize: "12px",
                        margin: "auto",
                        chips: {
                          background: "#4D9BD7",
                          borderRadius: "3px",
                          margin: "3px",
                        },
                        option: { color: "black", backgroundColor: "white" },
                        inputField: { margin: "-5px 5px", height: "40px" },
                        searchBox: {
                          padding: "0px",
                          height: "150px",
                          overflow: "auto",
                          // width: "500px",
                        },
                      }}
                    />
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.inclusive_services == ""
                        ? "Inclusive Services Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                    Instructions
                    </label>
                                        {/* <TagsInput
                      value={language}
                      id="taginput"
                      onChange={(e) => {
                        // console.log(e)
                        langfield(e);
                      }}
                      onChangeInput={(e) => {
                        console.log(e);
                      }}
                      validationRegex={/^[A-Za-z]+$/}
                      addOnBlur={true}
                      addOnPaste={true}
                      className="react-tagsinput-language"
                      name="instructions"
                      inputProps={{
                        placeholder: "",
                      }}
                    /> */}
                                        <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="instructions"
                      value={packagesdata.instructions}
                      style={{ resize: "none"}}
                      onChange={(e) => validation(e)}
                      rows="3"
                    ></textarea>
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                    Package Description
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="package_description"
                      value={packagesdata.package_description}
                      style={{ resize: "none"}}
                      onChange={(e) => validation(e)}
                      rows="3"
                    ></textarea>

                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.description == ""
                        ? "Date Time  Required"
                        : ""}
                    </p> */}
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                    Time Required
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="time_required"
                      value={packagesdata.time_required}
                      style={{ resize: "none"}}
                      onChange={(e) => validation(e)}
                      rows="3"
                    ></textarea>

                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && packagesdata.description == ""
                        ? "Date Time  Required"
                        : ""}
                    </p> */}
                  </div>
                  <div
                    class="form-group col-md-4 p-2 m-0"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="need_prescription"
                      checked={checked}
                      onChange={(e) => checkbox(e)}
                      style={{ margin: "auto" }}
                      id="invalidCheck"
                    ></input>
                    <label
                      class="form-check-label"
                      for="invalidCheck"
                      style={{ margin: "24px" }}
                    >
                      Need Prescription
                    </label>
                  </div>
                  <div class="col-md-2 mr-3"                     style={{ display: "flex", alignItems: "center" }}
>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        checked={checked1}
                        name="featured_product"
                        onChange={(e) => checkbox1(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                        Featured Packages
                      </label>
                    </div>
                  </div>
                  <div
                    class="col-md-4"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="is_active"
                        checked={isactive}
                        onChange={(e) => checkbox2(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                        Is Active
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-row">

                </div>
                <div
                  class="form-row mt-5"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="col-md-6 p-1 m-0">
                    <div className="form-group preview">
                      <div className="imgouters" style={{ display: "flex" }}>
                        {file &&
                          file.length > 0 &&
                          file.map((item, index) => {
                            return (
                              <>
                                <img
                                  onClick={(e) => {
                                    window.open(item);
                                  }}
                                  className="pointer"
                                  style={{
                                    height: "2.5rem",
                                    width: "2.5rem",
                                    borderRadius: "50%",
                                    margin: "10px 10px 10px 20px",
                                  }}
                                  src={item}
                                  alt=""
                                />
                                <button
                                  type="button"
                                  style={{
                                    position: "relative",
                                    height: "20px",
                                    width: "20px",
                                    margin: "-10px",
                                    borderRadius: "50%",
                                    backgroundColor: "#1b5a90",
                                  }}
                                  onClick={() => deleteFile(index)}
                                >
                                  <i
                                    class="bi bi-x"
                                    style={{
                                      margin: "inherit",
                                      color: "white",
                                      position: "relative",
                                      bottom: "2px",
                                    }}
                                  ></i>
                                </button>
                              </>
                            );
                          })}
                      </div>
                    </div>

                    <div className="form-group"></div>
                    <Button
                      className="pharmacyupload"
                      variant="contained"
                      component="label"
                      disabled={file && file.length > 5}
                    >
                      {" "}
                      <input
                        type="file"
                        disabled={file && file.length > 5}
                        hidden
                        className="form-control"
                        accept="image/png, image/jpeg"
                        onChange={uploadSingleFile}
                        multiple
                      />
                      Upload Investigation Images
                    </Button>
                  </div>
                  <div
                    className="col-md-6 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <>
                      {url ? (
                        <img
                          src={url}
                          onClick={(e) => {
                            window.open(url);
                          }}
                          className="pointer"
                          style={{
                            height: 115,
                            width: 115,
                            marginRight: 25,
                            borderRadius: "50%",
                          }}
                          alt="Image"
                        />
                      ) : (
                        <p style={{ margin: 0, padding: 10 }}>
                          Upload Featured Image
                        </p>
                      )}

                      {!url ? (
                        <Button
                          className="doctorupload"
                          variant="contained"
                          component="label"
                        >
                          <p>
                            Upload Image
                            <input
                              type="file"
                              hidden
                              accept="image/png, image/jpeg"
                              onChange={(e) => handleFiles(e)}
                            />
                          </p>
                        </Button>
                      ) : (
                        <></>
                      )}

                      {url ? (
                        <Button
                          className="remove"
                          variant="contained"
                          onClick={(e) => cancel(e)}
                        >
                          {" "}
                          <p>Remove Image</p>
                        </Button>
                      ) : (
                        ""
                      )}
                    </>
                  </div>
                </div>
                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group col-md-12 pb-3 pt-4 m-0">
                    <button
                      type="submit"
                      class="btn btn-primary  create"
                      onClick={(e) => newusercreate(e)}
                      disabled={
                        packagesstate == "Edit" && !alert ? true : false
                      }
                    >
                      {packagesstate == "Edit"
                        ? "Update Packages"
                        : "Create Packages"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {CroppImageView && (
        <div className="Cropper_Wrapper">
          <div className="Cropper_Inner_Wrapper">
            <ReactCrop
              src={imgsrc}
              crop={crop}
              ruleOfThirds
              onImageLoaded={onImageLoaded}
              onChange={(c) => {
                setCrop(c);
                console.log(c);
              }}
              // onComplete={(c) => setCompletedCrop(c)}
            >
              <img src={imgsrc} ref={imgRef} id="localimg" />
            </ReactCrop>
          </div>
          <div className="CropperFooter">
            <button onClick={(e) => setCroppImageView(false)}>Cancel</button>
            <button onClick={(e) => setCompletedCrop(crop)}>Save</button>
          </div>
        </div>
      )}
    </>
  );
}
